// CD code
$(document).ready(function() {
  if($('.video_play_icon').length){
    $(document).on('click', ".video_play_icon", function(){
      var video = $(this).parent().find('video').get(0);
      var play_button = $(this);
       if (video.paused) {
          video.play();
          play_button.hide();   
         $(video).attr("controls", true);
       } 
       // else {
       //    video.pause();
       //    play_button.show();
       // }
    });
  }
  
  // if($('.text_video').length){
  //   $(document).on('click', ".text_video", function(){
  //     var play_button = $(this).parent().find('.video_play_icon');
  //     var video = $(this).get(0);
  //     console.log(video.paused)
  //       if (video.paused ) {
  //           video.play();
  //           play_button.hide();   
  //        } 
  //        // else {
  //        //  video.pause();
  //        //    play_button.show();
  //        // }
  //   });
  // }

  if($('.custom_review .review_inner .more_info').length){
    $(document).on('click', '.custom_review .review_inner .more_info', function(elem){
      if($(this).hasClass('read_less')){
         $(this).removeClass("read_less");
         $(this).parents('.review_more_info').find('.review_desc').addClass('text_ellipsis');
         $(this).find('span').text("READ MORE")
      }else{  
        $(this).addClass("read_less");
        $(this).parents('.review_more_info').find('.text_ellipsis').removeClass('text_ellipsis');
        $('.custom_review .review_inner .more_info.read_less span').text("READ LESS")
      }
    });
  }

  $(".template_index .flickity-page-dots").each(function(elem){
    var flickity_dot = $(this).width() / 2;
    var window_width = $(this).parents('.flickity-enabled').width() / 2;
    var btn_postion = (window_width - 37) - flickity_dot;
    $(this).parents('.flickity-enabled').find('.flickity-button.previous').css("left", btn_postion+"px");
    $(this).parents('.flickity-enabled').find('.flickity-button.next').css("right", btn_postion+"px");
  });

    $(document).on("click", '.tab_collections .collcetion_title',function(){
      $(".tab_collections .collcetion_title.is_active").removeClass('is_active');
      $(".tab_collections .collcetion_title[data_index="+ $(this).attr('data_index') +"]").addClass("is_active");
      $(".tab_collections .tab_collection_list .tab_collection_grid").removeClass("show_grid");
      $(".tab_collections .tab_collection_list .tab_collection_grid[grid_product_id="+ $(this).attr('data_index') +"]").addClass("show_grid");
    });
  
  $(document).on("change", '.tab_collections .collection_inner .header .collection_select_box select',function(){
    var current_value = $(".tab_collections .collection_inner .header .collection_select_box select").val();
    $(".tab_collections .tab_collection_list .tab_collection_grid").removeClass("show_grid");
    $(".tab_collections .tab_collection_list .tab_collection_grid[grid_product_id="+ current_value +"]").addClass("show_grid");
  })
  
});

document.addEventListener("DOMContentLoaded", () => {
  if(document.querySelector('.custom_review .review_inner .review_list')){
  var reviewLists = document.querySelectorAll('.custom_review .review_inner .review_list');
  reviewLists.forEach(function(elem) {
    var flkty = new Flickity( elem, {
      cellAlign: 'left',
      contain: true,
      prevNextButtons: true,
      pageDots: true,
      groupCells: true,
      wrapAround: true
    });
  });
  }

   if(document.querySelector('.video_slider .video_list')){
    var video_list = document.querySelectorAll('.video_slider .video_list');
     video_list.forEach(function(elem){
      var flkty = new Flickity( elem, {
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        groupCells: true,
        wrapAround: true
      });
    })
  }

  setTimeout(function(){
  var r = document.querySelector(':root');
  if(document.querySelectorAll('.marquee_list').length) r.style.setProperty('--marquee-width', '-'+document.querySelector('.marquee_list .marque_list:first-child').clientWidth+'px');
  }, 2000);
});

// 

function ToggleMobileMenu() {
  mobile_menu.$data.open = !mobile_menu.$data.open;
}

function update_discountText() {
  if($("#variantsJSON").length) {
    let $matched, opt_index, val, filtered_var;
    const variants = JSON.parse($("#variantsJSON").text());
    $('.variants_group .rad_variant:checked').each(function(){
      opt_index = $(this).parents(".variant_input").attr("data-index");
      val = $(this).prop('value');
      filtered_var = variants.filter(function(_variant){
        return _variant.options[opt_index] == val
      });
      filtered_var.map(function(_variant){
        const options = _variant.options.filter(function(opt) {
          return opt != val
        });
        options.map(function(option){
          $matched = $('.variants_group .rad_variant[value="'+option+'"]').parents(".variant_input");
          if(_variant.discount_text != null) $matched.find(".discount_text").text(_variant.discount_text);
        });
      })
    });
  }
}

$(document).ready(function() {
  update_discountText();
  $(document).on("change",".rad_variant",function(){
    update_discountText();
  });  
});


$(document).on('click', ".dawn_featured_collection_grid .featured_collections .collection_product_list .product_add_to_cart .atc_btn", function(event) {
  event.preventDefault();
  var dawn_grid_pro = $(this).parents('.product_info');
  var atc_btn_id = parseInt(dawn_grid_pro.find(".variant-options .variant-radios .variant-label input:checked").val());
  var selling_plan = dawn_grid_pro.find(".subscription_select_box").val();
 if (dawn_grid_pro.find('input.pro_var[type="hidden"]').length) {
      atc_btn_id = dawn_grid_pro.find('input.pro_var[type="hidden"]').val();
    }
  var data = {
    id: atc_btn_id,
    quantity: 1
  };

  if (selling_plan) {
    data.selling_plan = selling_plan;
  }

  $.ajax({
    url: '/cart/add.js',
    type: 'POST',
    dataType: 'json',
    data: data,
    success: function(response) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          data: response
        }
      }));
    }
  });
});



$(document).on("change", ".dawn_featured_collection_grid .featured_collections .collection_product_list .variant-options .variant-radios .variant-label input", function(){
 var var_price = $(this).attr("data-product-price");
  console.log($(this).parents(".product_info").find(".subscription_select_box"))
  $(this).parents(".product_info").find(".grid_pro_price").text(var_price);
});

document.addEventListener("DOMContentLoaded", function () {
if (document.querySelector(".shipping_returns")) {
 fetch('https://ipinfo.io/json')
    .then(function(res) {
      return res.json();
    })
    .then(function(data) {
      var country = data.country.toLowerCase();
      var shippingData = document.getElementById('shipping-data');
      var output = document.getElementById('shipping-info');

      if (!shippingData || !output) return;
      if(country == 'gb'){
        country = 'uk';
      }
      
      var content =
        shippingData.dataset[country] ||
        shippingData.dataset.default;

      output.innerHTML = content || 'Shipping info not available.';
    })
    .catch(function(error) {
      console.error('Geo IP fetch failed:', error);
      // Optional: fallback content
      var shippingData = document.getElementById('shipping-data');
      var output = document.getElementById('shipping-info');
      if (shippingData && output) {
        output.innerHTML = shippingData.dataset.default || 'Shipping info not available.';
      }
    });
  }
});
  